import { IconProps } from './index';

const TwitterIcon = ({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & IconProps) => {
    return (
        <svg
            width={22}
            height={18}
            viewBox="0 0 22 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M21.162 2.656a8.383 8.383 0 01-2.402.658A4.196 4.196 0 0020.6 1c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 00-7.126 3.814 11.874 11.874 0 01-8.62-4.37 4.168 4.168 0 00-.566 2.103c0 1.45.738 2.73 1.86 3.48a4.168 4.168 0 01-1.894-.522v.052a4.185 4.185 0 003.355 4.1 4.209 4.209 0 01-1.89.073A4.185 4.185 0 006.97 13.65a8.393 8.393 0 01-6.191 1.732 11.83 11.83 0 006.41 1.88c7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54a8.495 8.495 0 002.087-2.165l-.001-.001z"
                fill="currentColor"
            />
        </svg>
    );
};

export default TwitterIcon;
